import Button from "../../components/NewButton";
import "./Planes.css";
import Imageinit from "../../assets/ImagInit.jpg";
import AppContext from "../../context/AppContext";
import { Col, Row } from "react-bootstrap";

export default function Planes() {
  if (AppContext.user && !AppContext.register) {
    window.location.href = "/signup";
  } else {
    return (
      <>
        <div className="start">
          <Row style={{ marginTop: "10px" }}>
            <Col
              md={12}
              style={{
                textAlign: "center",
                alignSelf: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <h1 style={{ fontWeight: "bold" }} className="titleForm">
                Planes que se adaptan a tu negocio
              </h1>
              <h5 style={{ marginBottom: "10px" }}>
                Desde pequeños emprendimientos hasta cadenas consolidadas,
                tenemos un plan justo para ti.
                <br /> Sin contratos complicados. Sin sorpresas.
              </h5>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px", textAlign: "center" }}>
            <Col
              md={4}
              style={{
                textAlign: "center",
                alignSelf: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <div
                style={{
                  borderStyle: "solid",
                  borderColor: "grey",
                  borderRadius: 50,
                  padding: 20,
                }}
              >
                <h3 className="titleForm">
                  Plan Básico
                  <br />
                  <strong>EMPRENDE</strong>
                </h3>
                <h5>
                  Ideal para: <br />
                  food trucks y locales pequeños.
                </h5>
                <h1
                  style={{
                    fontWeight: "bold",
                    color: "#F04B22",
                    marginBottom: 0,
                  }}
                >
                  $299
                </h1>
                <h4
                  style={{
                    fontWeight: "bold",
                    color: "#F04B22",
                    marginBottom: 0,
                  }}
                >
                  MXN/ mes
                </h4>
                <br />
                <ul style={{ textAlign: "left", listStyle: "disc" }}>
                  <li>Punto de venta básico</li>
                  <li>Menú digital dinámico</li>
                  <li>Pedidos desde la mesa</li>
                  <li>Soporte vía chat</li>
                  <li>Hasta 2 empleados</li>
                  <li>Reseñas a tu negocio</li>
                  <li>Turnero (Sólo para Food trucks)</li>
                  <li>Hasta 10 mesas (Sólo para Restaurantes)</li>
                </ul>
                <Button
                  redirectTo={"/"}
                  filled={true}
                  text={"Iniciar con este plan"}
                ></Button>
              </div>
            </Col>
            <Col
              md={4}
              style={{
                alignItems: "center",
                alignSelf: "center",
                padding: "30px",
              }}
            >
              <div
                style={{
                  borderStyle: "solid",
                  borderColor: "grey",
                  borderRadius: 50,
                  padding: 20,
                }}
              >
                <h3 className="titleForm">
                  Plan Profesional
                  <br />
                  <strong>CRECIMIENTO</strong>
                </h3>
                <h5>
                  Ideal para: <br />
                  restaurantes en expansión
                </h5>
                <h1
                  style={{
                    fontWeight: "bold",
                    color: "#F04B22",
                    marginBottom: 0,
                  }}
                >
                  $299
                </h1>
                <h4
                  style={{
                    fontWeight: "bold",
                    color: "#F04B22",
                    marginBottom: 0,
                  }}
                >
                  MXN/ mes
                </h4>
                <br />
                <h5>TODO LO ANTERIOR MÁS:</h5>
                <ul style={{ textAlign: "left", listStyle: "disc" }}>
                  <li>Menú digital dinámico</li>
                  <li>Pedidos desde la mesa</li>
                  <li>Soporte vía chat</li>
                  <li>Hasta 2 empleados</li>
                  <li>Reseñas a tu negocio</li>
                  <li>Turnero (Sólo para Food trucks)</li>
                  <li>Hasta 10 mesas (Sólo para Restaurantes)</li>
                </ul>
                <Button
                  redirectTo={"/"}
                  filled={true}
                  text={"Iniciar con este plan"}
                ></Button>
              </div>
            </Col>
            <Col
              md={4}
              style={{
                alignItems: "center",
                alignSelf: "center",
                padding: "30px",
              }}
            >
              <div
                style={{
                  borderStyle: "solid",
                  borderColor: "grey",
                  borderRadius: 50,
                  padding: 20,
                }}
              >
                <h3 className="titleForm">
                  Plan Empresarial
                  <br />
                  <strong>FULL SERVICE</strong>
                </h3>
                <h5>
                  Ideal para:
                  <br /> food trucks y locales pequeños.
                </h5>
                <h1
                  style={{
                    fontWeight: "bold",
                    color: "#F04B22",
                    marginBottom: 0,
                  }}
                >
                  $299
                </h1>
                <h4
                  style={{
                    fontWeight: "bold",
                    color: "#F04B22",
                    marginBottom: 0,
                  }}
                >
                  MXN/ mes
                </h4>
                <br />
                <ul style={{ textAlign: "left", listStyle: "disc" }}>
                  <li>Punto de venta básico</li>
                  <li>Menú digital dinámico</li>
                  <li>Pedidos desde la mesa</li>
                  <li>Soporte vía chat</li>
                  <li>Hasta 2 empleados</li>
                  <li>Reseñas a tu negocio</li>
                  <li>Turnero (Sólo para Food trucks)</li>
                  <li>Hasta 10 mesas (Sólo para Restaurantes)</li>
                </ul>
                <Button
                  redirectTo={"/"}
                  filled={true}
                  text={"Iniciar con este plan"}
                ></Button>
                {/* <img
                  style={{
                    alignSelf: "center",
                    borderRadius: "20px",
                    imageRendering: "",
                  }}
                  alt=""
                  className="image-start"
                  src={Imageinit}
                ></img> */}
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}
